"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPriceDifference = exports.formatMinorAmount = exports.formatMajorAmount = exports.toMajorUnit = exports.toMinorUnit = exports.parseToMinorUnit = exports.parseToMajorUnit = exports.CurrencyBN = void 0;
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const MINOR_UNITS = 2;
/*
 * DECIMAL_PLACES: maximum number of decimal places when using division
 * ROUNDING_MODE: use bankers' rounding
 */
exports.CurrencyBN = bignumber_js_1.default.clone({
    DECIMAL_PLACES: 2,
    ROUNDING_MODE: bignumber_js_1.default.ROUND_HALF_EVEN,
});
const parse = (value) => typeof value === 'string' ? value.replace(/[^0-9.-]+/g, '') : value;
/**
 * Returns a major unit number
 *
 * @param value A major unit string
 */
const parseToMajorUnit = (value) => new exports.CurrencyBN(Number(parse(value))).toNumber();
exports.parseToMajorUnit = parseToMajorUnit;
/**
 * Returns a minor unit number
 *
 * @param value A major unit string
 */
const parseToMinorUnit = (value) => (0, exports.toMinorUnit)(Number(parse(value)));
exports.parseToMinorUnit = parseToMinorUnit;
/**
 * converts value to minor (cent) amount (e.g. 5.99 -> 599)
 *
 * @param value A major unit value (5.99)
 */
const toMinorUnit = (value) => new exports.CurrencyBN(!value ? 0 : value)
    .decimalPlaces(MINOR_UNITS)
    .times(Math.pow(10, MINOR_UNITS))
    .toNumber();
exports.toMinorUnit = toMinorUnit;
/**
 * Converts value to major (dollar) amount (e.g. 599 -> 5.99)
 *
 * @param value A minor-unit value
 */
const toMajorUnit = (value) => new exports.CurrencyBN(!value ? 0 : value)
    .dividedBy(Math.pow(10, MINOR_UNITS))
    .toNumber();
exports.toMajorUnit = toMajorUnit;
/**
 * Formats a major unit amount to a currency string (i.e. 1.25 => "$1.25")
 *
 * @param majorAmount major unit amount
 * @param {CurrencyFormatOptions} options options object
 */
const formatMajorAmount = (majorAmount, { bcpTag = 'en-US', currency = 'USD', includeSymbol = true, } = {}) => {
    const formatter = new Intl.NumberFormat(bcpTag, {
        currency,
        style: 'currency',
    });
    return includeSymbol
        ? formatter.format(majorAmount)
        : formatter
            .formatToParts(majorAmount)
            .reduce((acc, { type, value }) => (type === 'currency' ? acc : acc + value), '');
};
exports.formatMajorAmount = formatMajorAmount;
/**
 * Formats a minor unit amount to a currency string (i.e. 125 => "$1.25")
 *
 * @param minorAmount minor unit amount
 * @param {CurrencyFormatOptions} options options object
 */
const formatMinorAmount = (minorAmount, options) => (0, exports.formatMajorAmount)((0, exports.toMajorUnit)(minorAmount), options);
exports.formatMinorAmount = formatMinorAmount;
const formatPriceDifference = (amount, options) => {
    return `${amount > 0 ? '+' : '-'}${(0, exports.formatMinorAmount)(Math.abs(amount), options)}`;
};
exports.formatPriceDifference = formatPriceDifference;
//# sourceMappingURL=index.js.map